// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddProdSubcat_importCsvCard__4Ep1c","addProdSubCatBtnContainer":"AddProdSubcat_addProdSubCatBtnContainer__73t0R"};